import apiWrapper from "Helpers/apiWrapper";
import { encodeParams } from "mailup-react-helpers";

import type { CategoryPagedList, FilterPagedList } from "Types/beFiltersApi";

const endpoints = ((baseURL: string) => {
  /* eslint-disable prettier/prettier */
  return {
    // filters
    getListOfFilters: (idList: number) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/filters`,
    // categories
    getListOfCategories: (params: GetListOfCategoriesReq) =>
      `${baseURL}/api/categories?${encodeParams(params) as string}`,
  };
  /* eslint-enable prettier/prettier */
})(process.env.BEFILTERS_URL as string);

export type FilterType =
  | "Anagraphic"
  | "Activity"
  | "Device"
  | "Geolocation"
  | "Engagement"
  | "MultiType"
  | "Tracking";

/**
 *
 * @param {number} idList ID of list
 * @param {Object} params
 * @param {number} params.pageSize The page size
 * @param {number} params.pageNumber The page number
 * @param {string} params.orderBy The column to order the result
 * @param {boolean} params.orderDescending Set true to order descending; otherwise ascending
 * @param {string} params.search Search filters by name (or description, id..)
 * @param {Array(number)} params.categories Search filters by category.
 * @param {boolean} params.hidden Search filters by hidden status
 * @param {Array('Anagraphic'|'Activity'|'Device'|'Geolocation'|'Engagement'|'MultiType'|'Tracking')} params.types Search filters by types
 *
 *
 */

interface GetListOfFiltersReq {
  pageSize: number;
  pageNumber: number;
  orderBy?: string;
  orderDescending?: boolean;
  search?: string;
  categories?: number[];
  hidden?: boolean;
  types: FilterType[];
}

export const beFiltersGetListOfFilters = async (
  idList: number,
  params: GetListOfFiltersReq,
): Promise<FilterPagedList> => {
  const url = endpoints.getListOfFilters(idList);
  return await apiWrapper({
    method: "post",
    url,
    data: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(({ data }) => data);
};

/**
 *
 * @param {Object} params
 * @param {number} params.pageSize The page size
 * @param {number} params.pageNumber The page number
 * @param {string} params.orderBy The column to order the result
 * @param {boolean} params.orderDescending Set true to order descending; otherwise ascending
 * @param {string} params.name Search filters by name
 *
 */

interface GetListOfCategoriesReq {
  pageSize: number;
  pageNumber: number;
  orderBy?: string;
  orderDescending?: boolean;
  name?: string;
}

export const beFiltersGetListOfCategories = async (
  params: GetListOfCategoriesReq,
): Promise<CategoryPagedList> => {
  const url = endpoints.getListOfCategories(params);
  return await apiWrapper({
    method: "get",
    url,
  }).then(({ data }) => data);
};

export const FILTER_TYPE_DEVICE = "Device";
export const FILTER_TYPE_ENGAGEMENT = "Engagement";
